import React from 'react';

import { Row, RowCell } from '../Row/Row';
import { Input } from '../Input/Input';
import { useIntl } from 'react-intl';
import { TranslateMessage } from 'src/components/shared/Translations/TranslateMessage/TranslateMessage';
import { UseFormMethods } from 'react-hook-form';
import { getMobileFieldValues } from '../../../hooks/state/useRegistrationState/utils';
import { useUrlQuery } from '../../../hooks/useUrlQuery/useUrlQuery';

interface Props {
  register: UseFormMethods['register'];
  errors: UseFormMethods['errors'];
  isMobile?: boolean;
}

export const EmailInputField: React.FC<Props> = ({
  register,
  errors,
  isMobile,
}) => {
  const intl = useIntl();
  const { emailMobile } = getMobileFieldValues(isMobile);
  const urlSearchParams = useUrlQuery();

  const urlEmail = urlSearchParams.get('email') || '';
  const initialEmail = urlEmail === 'undefined' ? '' : urlEmail;

  return (
    <Row>
      <RowCell>
        <Input
          defaultValue={emailMobile || initialEmail}
          name="email"
          register={register}
          width={300}
          placeholder={intl.formatMessage({
            id: 'general.emailAddress',
          })}
          seleniumAttribute={'login-email-input'}
          theme={'grey'}
          iconName={'envelope'}
          tooltipErrorMessage={
            errors.email ? (
              errors.email?.type === 'email' ? (
                <TranslateMessage id="component.RegisterPage.invalidEmail" />
              ) : (
                <TranslateMessage id="component.RegisterPage.emailAddressRequired" />
              )
            ) : (
              undefined
            )
          }
          tooltipPlacement="right"
        />
      </RowCell>
    </Row>
  );
};
